module.exports = __webpack_public_path__ + "media/newstyle/images/instagram-share-pink-71659db9b32fb1a882070101966233d2.svg";